module.exports = __webpack_public_path__ + "static/media/ui_ux.25116251.jpg";